<template>  
  <div id="navButton" @click="togglePanel">
    <div id="menuHolder">
      <div id="openMenuBarOne" class="menuBar bar"></div>
      <div id="openMenuBarTwo" class="menuBar bar"></div>
    </div>
    <div id="crossHolder">
      <div id="crossMenuBarOne" class="crossBar bar"></div>
      <div class="crossBar bar"></div>
    </div>
    <div id="buttonMenuBackground">
    </div>
  </div>
  <div id="panelHolder" :class="isOpen ? 'panelOpen' : 'panelClose'">
    <router-link to="/" :class="'pageName' + ($route.name === 'Home' ? ' disabled' : ' ') " @click="togglePanel">
      <p class="id">
        01
      </p>
      <p class="text">
        HOME
      </p>
    </router-link>
    <router-link to="/projects" :class="$route.name === 'Projects' ? 'pageName disabled' : 'pageName'" @click="togglePanel">
      <p class="id">
        02
      </p>
      <p class="text">
        PROJECTS
      </p>
    </router-link>
    <router-link to="/about" :class="$route.name === 'About' ? 'pageName disabled' : 'pageName'" @click="togglePanel">
      <p class="id">
        03
      </p>
      <p class="text">
        ABOUT
      </p>
    </router-link>
    <footer id="socials">
      <a href="https://twitter.com/Simon349_" target="_blank">twitter.</a>
      <a href="mailto:simon.tessier8@gmail.com" target="_blank">email.</a>
      <a href="https://github.com/Wizer21" target="_blank">github.</a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Navigator',
  data(){
    return {
      isOpen: true,
      route: ""
    }
  },
  methods: {
    togglePanel(){
      const crosses = document.getElementsByClassName('crossBar')
      const bars = document.getElementsByClassName('menuBar')
      const pages = document.getElementsByClassName('pageName')

      if(this.isOpen){
        // Close Menu Cross
        crosses[0].style.transitionDelay = "0ms"
        crosses[1].style.transitionDelay = "200ms"

        for (let cross of crosses){
          cross.style.clipPath = "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)"
        }

        // Open Menu Button
        bars[0].style.transitionDelay = "350ms"
        bars[1].style.transitionDelay = "550ms"

        for (let bar of bars){
          bar.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 0% 100%)"
        }

        // Close links
        for (let page of pages){
          page.style.transitionDelay = `0ms`
          page.style.transitionDuration = "250ms"

          page.style.transform = "translateY(50%) rotate(5deg)"
          page.style.opacity = "0"
        }
      }
      else{
        // Close Menu Button
        bars[0].style.transitionDelay = "0ms"
        bars[1].style.transitionDelay = "200ms"

        for (let bar of bars){
          bar.style.clipPath = "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)"
        }

        // Open Menu Cross
        crosses[0].style.transitionDelay = "350ms"
        crosses[1].style.transitionDelay = "550ms"

        for (let cross of crosses){
          cross.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 0% 100%)"
        }

        // Open links
        let i = 0
        for (let page of pages){
          page.style.transitionDuration = "400ms"
          page.style.transitionDelay = `${500 + 150*i}ms`

          page.style.transform = "translateY(0%) rotate(0deg)"
          page.style.opacity = ""

          i++
        }
      }
      this.isOpen = !this.isOpen
    }
  },
  mounted(){
    this.togglePanel()
  }
}
</script>

<style scoped>
/* Links */
.id
{
  margin: 0;
}
.pageName
{
  transition: transform 300ms ease-out, opacity 300ms ease-out;

  display: flex;
  align-items: center;
  width: min-content;
}
.pageName p
{
  height: min-content;
}
.text
{
  transition: border-bottom 200ms ease-out;
  border-bottom: 0.5vh solid transparent;

  margin: 0;
  margin-top: 1vh;
}
.pageName:hover .text
{
  border-bottom: 0.5vh solid white;
}
/* Panels */
#panelHolder
{
  position: fixed;
  height: 100%;
  width: 100vw;
  z-index: 60;
  
  padding: 4vh;

  transition: transform 700ms ease-in-out, opacity 700ms ease-in-out;
  background-color: #111111;

  display: flex;
  flex-direction: column;
  justify-content: center;
}
.panelClose
{
  transform: translateY(100vh);
  opacity: 0;
}
.panelOpen
{
  transform: translateY(0vh);
  opacity: 1;
}
/* Button */
#navButton
{
  position: fixed;
  z-index: 61;
  top: 0;
  right: 0;

  height: 5vh;
  width: 5vh;

  cursor: pointer;
  mix-blend-mode: difference;
}
#menuHolder,
#crossHolder
{
  position: absolute;
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
}
#menuHolder
{
  justify-content: space-evenly;
  align-items: flex-end;  
}
#crossHolder
{
  justify-content: center;
  align-items: center;

  margin-left: 14%;
  margin-top: 4%;
}
/* Button background */
#buttonMenuBackground
{
  position: absolute;
  height: 175%;
  width: 175%;

  margin-left: -50%;

  border: 2px solid #f5f5f5;

  transition-duration: 300ms;
  transition-timing-function: ease-out;
  clip-path: circle(0% at 100% 0);
}
#navButton:hover #buttonMenuBackground
{
  clip-path: circle(150% at 100% 0);
}
/* Bars */
.bar
{
  transition-duration: 500ms;
  background-color: #f5f5f5;

  transition-timing-function: ease-out;
}
/* Menu */
#openMenuBarOne
{
  width: 80%;
}
#openMenuBarTwo
{
  width: 40%;
}
/* Cross */
.crossBar
{  
  width: 100%;
  transform: rotate(45deg);

  background-color: #f5f5f5;
}
#crossMenuBarOne
{
  transform: rotate(-45deg) translate(-3%, 60%);
}
.disabled
{
  pointer-events: none;
  opacity: 0.1;
}
/* Footer */
#socials
{
  position: fixed;
  bottom: 0;
  right: 0;
}
#socials a
{
  color: #f5f5f5;
  margin-left: 2vh;
  text-decoration: underline;
}
.bar
{
  height: 2px;
}
@media screen and (orientation: landscape) {
  .id
  {
    font-size: 4vh;
    margin-right: 4vh;
  }
  .pageName
  {
    margin: 3vh 0;
  }
  .text
  {
    font-size: 15vh;
    line-height: 12vh;
  }
  #navButton
  {    
    margin: 1.8vh 3vh;
  }
  #socials
  {
    padding: 3vh;
  }
}
@media screen and (orientation: portrait) {
  .id
  {
    font-size: 4vw;
    margin-right: 4vw;
  }
  .pageName
  {
    margin: 3vw 0;
  }
  .text
  {
    font-size: 15vw;
    line-height: 12vw;
  }
  #navButton
  {    
    margin: 2vw 4.3vw;
  }
  #socials
  {
    padding: 1.5vh;
  }
}
</style>